import React, { useRef } from "react";
import {useDispatch } from "react-redux";
import { logout } from "redux/reducers/loggedInUser";
import { env } from "configs/EnvironmentConfig";

export default function VersionCheck() {
// const IdleTimeRef = useRef(null);
const distpatch = useDispatch();
const version = localStorage.getItem('app_version');
const envVersion = env.APP_VERSION;
console.log("versionCheck",version);
console.log("envVersion",envVersion);
  const onIdle = () => {
        distpatch(logout());
    };

    if(version !== envVersion){
        onIdle();
        // console.log(envVersion);
    }

    return (
        <>
          <div class="row"></div>
        </>
      );

}
